import React from 'react';
import { DELETAR_CUSTO_POST } from '../../Api';
import useFetch from '../../Hooks/useFetch';
import styles from './Requests.module.css';

const DeletarCusto = ({ id }) => {
  const { loading, request } = useFetch();

  async function handleClick(event) {
    const confirm = window.confirm('Tem certeza que deseja deletar?');
    if (confirm) {
      const { url, options } = DELETAR_CUSTO_POST(id);
      const { response } = await request(url, options);
      if (response.ok) window.location.reload();
    }
  }

  return (
    <>
      {loading ? (
        <button className={styles.delete} disabled>
          Deletar
        </button>
      ) : (
        <button onClick={handleClick} className={styles.delete}>
          Deletar
        </button>
      )}
    </>
  );
};

export default DeletarCusto;
